export default __webpack_public_path__ + "static/image1-ec515e2b6b116f6c0edf157552ff09fa.gif";